import React, { useState, useEffect } from 'react'
import TopBanner from '../../../components/topBanner/topBanner'
import imgBanner from "../../../images/banner/banner-tin-tuc.jpg"
import TitleCenter from '../../../components/title/TitleCenter'
import { ImHome } from "react-icons/im";
import { ImOffice } from "react-icons/im";
import { ImPhone } from "react-icons/im";
import { HiEnvelope } from "react-icons/hi2";
import { BsFileEarmarkCheck } from "react-icons/bs";
import { FiMapPin, FiExternalLink } from "react-icons/fi";
import { useLanguage } from '../../../hooks/useLanguage';
import { getContactsByLanguage } from '../../../apis/contacts';
import { getBusinessLicenseByLanguage } from '../../../apis/businessLicenses';
import { useNavigate, useLocation } from 'react-router-dom';

const CONTACT_LABELS = {
  vi: {
    title_center: "HEALTHCARE SOLUTION VIET NAM",
    page_name: "Trang Chủ",
    text: "Liên Hệ",
    title: "Liên Hệ",
    maps_title: "Google Maps - Hồ Chí Minh",
  },
  en: {
    title_center: "HEALTHCARE SOLUTION VIET NAM",
    page_name: "Home",
    text: "Contact",
    title: "Contact",
    maps_title: "Google Maps - Ho Chi Minh",
  },
};

// Maps hardcoded by sortOrder (API does not provide map URLs)
const OFFICE_MAPS = {
  1: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.6245406824255!2d106.69240167872307!3d10.763392262013491!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752f87c1cf62ed%3A0x10008462ce750002!2zMjMyIFbDtSBWxINuIEtp4buHdCwgUGjGsOG7nW5nIEPhuqd1IMOUbmcgTMOjbmgsIFF14bqtbiAxLCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmggNzEwMTEsIFZpZXRuYW0!5e0!3m2!1sen!2sus!4v1684991116502!5m2!1sen!2sus",
  2: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.8673882854823!2d106.69150277872122!3d10.74470236207624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752fa08dcace2f%3A0x2541e06018f85edf!2zNjQgxJDGsOG7nW5nIHPhu5EgMiwgVMOibiBIxrBuZywgUXXhuq1uIDcsIFRow6BuaCBwaOG7kSBI4buTIENow60gTWluaCwgVmlldG5hbQ!5e0!3m2!1sen!2sus!4v1684990612566!5m2!1sen!2sus",
};

function Contact() {
  const { i18n, currentLang } = useLanguage();
  const [contacts, setContacts] = useState([]);
  const [labels, setLabels] = useState(CONTACT_LABELS.vi);
  const [bizLicense, setBizLicense] = useState(null);

  const loadContacts = async () => {
    try {
      const data = await getContactsByLanguage(currentLang);
      setContacts(data);
      setLabels(CONTACT_LABELS[currentLang] || CONTACT_LABELS.vi);
    } catch (error) {
      console.error('Lỗi khi tải danh sách liên hệ:', error);
      setLabels(CONTACT_LABELS[currentLang] || CONTACT_LABELS.vi);
    }
  };

  const loadBizLicense = async () => {
    const data = await getBusinessLicenseByLanguage(currentLang);
    setBizLicense(data);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    loadContacts();
    loadBizLicense();
  }, [currentLang]);

  useEffect(() => {
    const expectedBasePath = currentLang === 'vi' ? '/lien-he' : '/contact';
    const currentPath = location.pathname;

    if (currentPath === '/lien-he' || currentPath === '/lien-he/' ||
        currentPath === '/contact' || currentPath === '/contact/') {
      if (!currentPath.startsWith(expectedBasePath)) {
        navigate(expectedBasePath, { replace: true });
      }
    }
  }, [currentLang, location.pathname, navigate]);

  return (
    <div className='contact-container'>
      <TopBanner
        titleCenter={labels.title_center}
        imgBanner={imgBanner}
        pageName={labels.page_name}
        text={labels.text}
      />
      <div className='layout_container'>
        <TitleCenter text={labels.title} />
        {bizLicense && (
          <div className="biz-registration-bar">
            <span className="biz-reg-icon"><BsFileEarmarkCheck /></span>
            <div className="biz-reg-content">
              <span className="biz-reg-label">{bizLicense.name}:</span>
              <span className="biz-reg-number">{bizLicense.licenseNumber}</span>
              <span className="biz-reg-issuer">{bizLicense.issuer}</span>
            </div>
          </div>
        )}
        <div className="contact-offices-list">
          {contacts.map((office) => (
            <div className="contact-office-card" key={office.id}>
              <div className="contact-card-inner">
                <div className="contact-info-side">
                  <div className="contact-office-header">
                    <div className="contact-office-badge">
                      <ImHome />
                    </div>
                    <div className="contact-office-title-wrap">
                      <h3 className="contact-office-title">{office.officeName}</h3>
                      <span className="contact-office-tag">
                        {office.sortOrder === 1
                          ? (currentLang === 'en' ? 'Headquarters' : 'Trụ sở chính')
                          : (currentLang === 'en' ? 'Branch Office' : 'Văn phòng chi nhánh')}
                      </span>
                    </div>
                  </div>

                  <div className="contact-info-grid">
                    {office.address && (
                      <div className="contact-info-item contact-info-item--full">
                        <div className="contact-info-icon-wrapper">
                          <ImHome />
                        </div>
                        <div className="contact-info-text-group">
                          <span className="contact-info-label">
                            {currentLang === 'en' ? 'Address' : 'Địa chỉ'}
                          </span>
                          <span className="contact-info-val">{office.address}</span>
                        </div>
                      </div>
                    )}

                    {office.phone && (
                      <div className="contact-info-item">
                        <div className="contact-info-icon-wrapper contact-info-icon-wrapper--phone">
                          <ImPhone />
                        </div>
                        <div className="contact-info-text-group">
                          <span className="contact-info-label">
                            {currentLang === 'en' ? 'Hotline / Phone' : 'Điện thoại'}
                          </span>
                          <a href={`tel:${office.phone.replace(/[^0-9+]/g, '')}`} className="contact-info-val contact-info-link">
                            {office.phone}
                          </a>
                        </div>
                      </div>
                    )}

                    {office.fax && (
                      <div className="contact-info-item">
                        <div className="contact-info-icon-wrapper contact-info-icon-wrapper--fax">
                          <ImOffice />
                        </div>
                        <div className="contact-info-text-group">
                          <span className="contact-info-label">
                            {currentLang === 'en' ? 'Fax / Office Tel' : 'Số Fax'}
                          </span>
                          <span className="contact-info-val">{office.fax}</span>
                        </div>
                      </div>
                    )}

                    {office.email && (
                      <div className="contact-info-item">
                        <div className="contact-info-icon-wrapper contact-info-icon-wrapper--email">
                          <HiEnvelope />
                        </div>
                        <div className="contact-info-text-group">
                          <span className="contact-info-label">
                            {currentLang === 'en' ? 'Email' : 'Email liên hệ'}
                          </span>
                          <a href={`mailto:${office.email}`} className="contact-info-val contact-info-link">
                            {office.email}
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="contact-map-side">
                  <div className="contact-square-map-wrapper">
                    {OFFICE_MAPS[office.sortOrder] ? (
                      <>
                        <div className="contact-square-map-box">
                          <iframe
                            src={OFFICE_MAPS[office.sortOrder]}
                            title={`${office.officeName} Map`}
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                          ></iframe>
                        </div>
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(office.address || office.officeName)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="contact-map-action-btn"
                        >
                          <FiMapPin />
                          <span>{currentLang === 'en' ? 'Open in Maps' : 'Xem bản đồ lớn'}</span>
                          <FiExternalLink />
                        </a>
                      </>
                    ) : (
                      <div className="contact-map-placeholder square-placeholder">
                        <ImHome />
                        <p>{currentLang === 'en' ? 'Map position unavailable' : 'Vị trí bản đồ đang cập nhật'}</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Contact